import { render } from "./tts.vue?vue&type=template&id=456d07e2"
import script from "./tts.vue?vue&type=script&lang=js"
export * from "./tts.vue?vue&type=script&lang=js"

import "./tts.vue?vue&type=style&index=0&id=456d07e2&lang=scss"

import exportComponent from "D:\\Workspace_git\\carrot\\pron_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__